import { IconPropsType } from '..';

export const BingoIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_15566_7266)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM7 12.6C10.0928 12.6 12.6 10.0928 12.6 7C12.6 3.90721 10.0928 1.4 7 1.4C3.90721 1.4 1.4 3.90721 1.4 7C1.4 10.0928 3.90721 12.6 7 12.6Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 11.9C9.7062 11.9 11.9 9.7062 11.9 7C11.9 4.2938 9.7062 2.1 7 2.1C4.2938 2.1 2.1 4.2938 2.1 7C2.1 9.7062 4.2938 11.9 7 11.9ZM7 11.2C9.3196 11.2 11.2 9.3196 11.2 7C11.2 4.6804 9.3196 2.8 7 2.8C4.6804 2.8 2.8 4.6804 2.8 7C2.8 9.3196 4.6804 11.2 7 11.2Z"
      />
      <path d="M9.8 7C9.8 8.5464 8.5464 9.8 7 9.8C5.4536 9.8 4.2 8.5464 4.2 7C4.2 5.4536 5.4536 4.2 7 4.2C8.5464 4.2 9.8 5.4536 9.8 7Z" />
    </g>
    <defs>
      <clipPath id="clip0_15566_7266">
        <rect
          width="14"
          height="14"
        />
      </clipPath>
    </defs>
  </svg>
);
